import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	linkToBoardsDirectory: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	linkToBoardsDirectory: {
		defaultMessage: 'Couldn’t find your boards? <a>View all boards</a>',
		id: 'home.tabs.boards.footer.link-to-boards-directory',
		description: 'A link that takes users to the boards directory when clicked',
	},
});
export default messages;
